import { pdfjs } from 'react-pdf';

const workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url
).toString();

let isConfigured = false;

export const ensurePdfWorker = () => {
  if (isConfigured) return;
  pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
  isConfigured = true;
};
